import * as React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { App } from './App'
import './index.css'

Sentry.init({
  dsn: 'https://42382f8f0e87db490002370d45d7f717@o4510650570702848.ingest.us.sentry.io/4510650584006656',
  tracesSampleRate: 0.1,
})

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
